import { render, staticRenderFns } from "./P2PLayout.vue?vue&type=template&id=69090cea&scoped=true&"
import script from "./P2PLayout.vue?vue&type=script&lang=js&"
export * from "./P2PLayout.vue?vue&type=script&lang=js&"
import style0 from "./P2PLayout.vue?vue&type=style&index=0&id=69090cea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69090cea",
  null
  
)

export default component.exports